(function () {
  'use strict';

  var GROUPS = [
    { key: 'vertical', title: 'Vertical Doors, Inc. Vertical Door Kits' },
    { key: 'zlr', title: 'Vertical Doors, Inc. ZLR Door Conversion Kits' },
    { key: 'aftermarket', title: 'Aftermarket Parts and Corvette Upgrades' },
    { key: 'apparel', title: 'Apparel' },
    { key: 'gift_card', title: 'Vertical Doors, Inc. Gift Card' },
    { key: 'other', title: 'Other Products' }
  ];

  var PRODUCT_TYPES = [
    { value: 'vertical', label: 'Vertical Door Kits' },
    { value: 'zlr', label: 'ZLR Door Conversion Kits' },
    { value: 'installation', label: 'Kit + At-Home Installation' },
    { value: 'aftermarket', label: 'C8 and aftermarket parts' },
    { value: 'apparel', label: 'Apparel' },
    { value: 'gift_card', label: 'Gift card (all vehicles)' }
  ];

  var PAGE_SIZE = 48;

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function uniqueSorted(values) {
    return Array.from(new Set(values.filter(Boolean))).sort(function (a, b) {
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  function addOption(select, value, label) {
    var option = document.createElement('option');
    option.value = value;
    option.textContent = label || value;
    select.appendChild(option);
  }

  function imageUrlAtWidth(source, width) {
    try {
      var url = new URL(source);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function fitmentText(product) {
    var vehicle = [product.make, product.model].filter(Boolean).join(' ');
    var years = '';
    if (product.yearMin && product.yearMax) {
      years = product.yearMin === product.yearMax ? String(product.yearMin) : product.yearMin + '-' + product.yearMax;
    }
    return [years, vehicle].filter(Boolean).join(' | ');
  }

  function normalizedWords(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[–—]/g, '-')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
  }

  function titleAlreadyStatesFitment(product) {
    var titleWords = normalizedWords(product.title);
    if (!titleWords.length) return false;

    var requiredVehicleWords = normalizedWords([product.make, product.model].filter(Boolean).join(' '));
    if (!requiredVehicleWords.length || !requiredVehicleWords.every(function (word) {
      return titleWords.indexOf(word) !== -1;
    })) {
      return false;
    }

    if (product.yearMin && titleWords.indexOf(String(product.yearMin)) === -1) return false;
    if (product.yearMax && titleWords.indexOf(String(product.yearMax)) === -1) return false;
    return true;
  }

  function productCtaLabel(product) {
    if (product.subtype === 'installation') return 'View At-Home Installation Package';
    if (product.category === 'vertical') return 'View VDI Vertical Door Kit';
    if (product.category === 'zlr') return 'View ZLR Door Conversion Kit';
    if (product.category === 'aftermarket') return 'View Aftermarket Part';
    if (product.category === 'apparel') return 'View Apparel';
    if (product.category === 'gift_card') return 'View VDI Gift Card';
    return 'View Product';
  }

  function productCard(product) {
    var image = product.image
      ? '<img src="' + escapeHtml(imageUrlAtWidth(product.image, 960)) + '"' +
          ' srcset="' + escapeHtml(imageUrlAtWidth(product.image, 480)) + ' 480w, ' +
          escapeHtml(imageUrlAtWidth(product.image, 960)) + ' 960w, ' +
          escapeHtml(imageUrlAtWidth(product.image, 1440)) + ' 1440w, ' +
          escapeHtml(imageUrlAtWidth(product.image, 1920)) + ' 1920w"' +
          ' sizes="(min-width: 990px) 33vw, (min-width: 750px) 50vw, 100vw"' +
          ' alt="' + escapeHtml(product.title) + '" loading="lazy" decoding="async" width="1920" height="1080">'
      : '<span class="vdi-product-card__placeholder">Image available on product page</span>';
    var fitment = fitmentText(product);
    var installationBadge = product.subtype === 'installation'
      ? '<div class="vdi-product-card__badges"><span class="vdi-product-card__badge">Kit + at-home installation</span></div>'
      : '';
    var sku = product.sku
      ? '<p class="vdi-product-card__sku">Part number: ' + escapeHtml(product.sku) + '</p>'
      : '';
    var fitmentMarkup = fitment && !titleAlreadyStatesFitment(product)
      ? '<p class="vdi-product-card__fitment">' + escapeHtml(fitment) + '</p>'
      : '';

    return '' +
      '<article class="vdi-product-card">' +
        '<a class="vdi-product-card__image" href="' + escapeHtml(product.url) + '">' + image + '</a>' +
        '<div class="vdi-product-card__body">' +
          installationBadge +
          '<h4><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a></h4>' +
          fitmentMarkup +
          sku +
          '<a class="vdi-product-card__cta" href="' + escapeHtml(product.url) + '">' + escapeHtml(productCtaLabel(product)) + '</a>' +
        '</div>' +
      '</article>';
  }

  function init(root, catalog) {
    var products = catalog.products || [];
    var form = root.querySelector('[data-vdi-form]');
    var yearSelect = root.querySelector('[data-vdi-year]');
    var makeSelect = root.querySelector('[data-vdi-make]');
    var modelSelect = root.querySelector('[data-vdi-model]');
    var categorySelect = root.querySelector('[data-vdi-category]');
    var searchInput = root.querySelector('[data-vdi-search]');
    var results = root.querySelector('[data-vdi-results]');
    var resultsTitle = root.querySelector('[data-vdi-results-title]');
    var resultsCount = root.querySelector('[data-vdi-results-count]');
    var resultsGroups = root.querySelector('[data-vdi-results-groups]');
    var empty = root.querySelector('[data-vdi-empty]');
    var loadMoreWrap = root.querySelector('[data-vdi-load-more-wrap]');
    var loadMoreButton = root.querySelector('[data-vdi-load-more]');
    var makeList = root.querySelector('[data-vdi-make-list]');
    var catalogCount = root.querySelector('[data-vdi-catalog-count]');
    var submitButton = root.querySelector('[data-vdi-submit]');
    var selectedSummary = root.querySelector('[data-vdi-selected-summary]');
    var changeToggle = root.querySelector('[data-vdi-change-toggle]');
    var visibleCount = PAGE_SIZE;
    var currentMatches = [];

    var vehicleProducts = products.filter(function (product) {
      return product.category !== 'apparel' && product.category !== 'gift_card';
    });

    var makes = uniqueSorted(vehicleProducts.map(function (product) {
      return product.make;
    }));

    var yearValues = products.reduce(function (years, product) {
      if (!product.yearMin || !product.yearMax || product.yearMax - product.yearMin > 80) return years;
      for (var year = product.yearMin; year <= product.yearMax; year += 1) years.add(year);
      return years;
    }, new Set());

    Array.from(yearValues).sort(function (a, b) { return b - a; }).forEach(function (year) {
      addOption(yearSelect, String(year), String(year));
    });
    populateMakes('');

    makeList.innerHTML = '';
    makes.forEach(function (make) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = make;
      button.setAttribute('data-make', make);
      makeList.appendChild(button);
    });

    catalogCount.textContent = catalog.productCount + ' active products indexed. Replacement shocks excluded.';

    function productAvailableForYear(product, selectedYear) {
      if (!selectedYear) return true;
      return Boolean(product.yearMin && product.yearMax && selectedYear >= product.yearMin && selectedYear <= product.yearMax);
    }

    function populateMakes(preferredMake) {
      var selectedYear = yearSelect.value ? Number(yearSelect.value) : null;
      var availableMakes = uniqueSorted(vehicleProducts.filter(function (product) {
        return productAvailableForYear(product, selectedYear);
      }).map(function (product) {
        return product.make;
      }));

      makeSelect.innerHTML = '';
      addOption(makeSelect, '', 'Select make');
      availableMakes.forEach(function (make) { addOption(makeSelect, make, make); });
      makeSelect.disabled = availableMakes.length === 0;
      if (preferredMake && availableMakes.indexOf(preferredMake) !== -1) makeSelect.value = preferredMake;
    }

    function populateModels(preferredModel) {
      var selectedMake = makeSelect.value;
      var selectedYear = yearSelect.value ? Number(yearSelect.value) : null;
      modelSelect.innerHTML = '';
      addOption(modelSelect, '', selectedMake ? 'All models' : 'Select model');
      if (!selectedMake) {
        modelSelect.disabled = true;
        return;
      }
      var models = uniqueSorted(vehicleProducts.filter(function (product) {
        return product.make === selectedMake && productAvailableForYear(product, selectedYear);
      }).map(function (product) {
        return product.model;
      }));
      models.forEach(function (model) { addOption(modelSelect, model, model); });
      modelSelect.disabled = models.length === 0;
      if (preferredModel && models.indexOf(preferredModel) !== -1) modelSelect.value = preferredModel;
    }

    function productMatchesVehicle(product) {
      var selectedYear = yearSelect.value ? Number(yearSelect.value) : null;
      var selectedMake = makeSelect.value;
      var selectedModel = modelSelect.value;

      if (product.category === 'gift_card') return true;
      if (selectedMake && product.make !== selectedMake) return false;
      if (selectedModel && product.model !== selectedModel) return false;

      if (selectedYear && product.category !== 'apparel') {
        if (!product.yearMin || !product.yearMax) return false;
        if (selectedYear < product.yearMin || selectedYear > product.yearMax) return false;
      }

      return true;
    }

    function populateProductTypes(preferredCategory) {
      var availableTypes = products.filter(productMatchesVehicle).reduce(function (types, product) {
        types.add(product.category);
        if (product.subtype === 'installation') types.add('installation');
        return types;
      }, new Set());

      categorySelect.innerHTML = '';
      addOption(categorySelect, '', 'All product types');
      PRODUCT_TYPES.forEach(function (choice) {
        if (availableTypes.has(choice.value)) addOption(categorySelect, choice.value, choice.label);
      });

      categorySelect.value = preferredCategory && availableTypes.has(preferredCategory) ? preferredCategory : '';
    }

    function productMatches(product) {
      var selectedCategory = categorySelect.value;
      var query = searchInput.value.trim().toLowerCase();

      if (!productMatchesVehicle(product)) return false;
      if (selectedCategory === 'installation' && product.subtype !== 'installation') return false;
      if (selectedCategory && selectedCategory !== 'installation' && product.category !== selectedCategory) return false;

      if (query) {
        var haystack = [product.title, product.make, product.model, product.sku, product.productType, product.vendor].join(' ').toLowerCase();
        if (haystack.indexOf(query) === -1) return false;
      }
      return true;
    }

    function selectedVehicleLabel() {
      var parts = [yearSelect.value, makeSelect.value, modelSelect.value].filter(Boolean);
      if (parts.length) return parts.join(' ');
      if (categorySelect.value) return categorySelect.options[categorySelect.selectedIndex].text;
      if (searchInput.value.trim()) return 'Search results';
      return 'All products';
    }

    function setResultsMode(active) {
      root.classList.toggle('vdi-finder--results-mode', active);
      if (!active) root.classList.remove('vdi-finder--filters-open');
      if (submitButton) submitButton.textContent = active ? 'Update Results' : 'Find matching products';
      if (selectedSummary) selectedSummary.textContent = selectedVehicleLabel();
      if (changeToggle) changeToggle.setAttribute('aria-expanded', root.classList.contains('vdi-finder--filters-open') ? 'true' : 'false');
    }

    function updateUrl() {
      if (!window.history || !window.history.replaceState) return;
      var params = new URLSearchParams(window.location.search);
      var values = {
        year: yearSelect.value,
        make: makeSelect.value,
        model: modelSelect.value,
        product_type: categorySelect.value,
        q: searchInput.value.trim()
      };
      Object.keys(values).forEach(function (key) {
        if (values[key]) params.set(key, values[key]);
        else params.delete(key);
      });
      var query = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
    }

    function renderMatches(scrollToResults) {
      currentMatches = products.filter(productMatches);
      var visible = currentMatches.slice(0, visibleCount);
      var groupHtml = '';

      GROUPS.forEach(function (group) {
        var allInGroup = currentMatches.filter(function (product) { return product.category === group.key; });
        var visibleInGroup = visible.filter(function (product) { return product.category === group.key; });
        if (!visibleInGroup.length) return;
        groupHtml += '' +
          '<section class="vdi-product-group" aria-labelledby="vdi-group-' + escapeHtml(group.key) + '">' +
            '<div class="vdi-product-group__heading">' +
              '<h3 id="vdi-group-' + escapeHtml(group.key) + '">' + escapeHtml(group.title) + '</h3>' +
              '<span>' + allInGroup.length + ' product' + (allInGroup.length === 1 ? '' : 's') + '</span>' +
            '</div>' +
            '<div class="vdi-product-grid">' + visibleInGroup.map(productCard).join('') + '</div>' +
          '</section>';
      });

      resultsTitle.textContent = selectedVehicleLabel();
      resultsCount.textContent = currentMatches.length + ' matching product' + (currentMatches.length === 1 ? '' : 's');
      resultsGroups.innerHTML = groupHtml;
      results.hidden = currentMatches.length === 0;
      empty.hidden = currentMatches.length !== 0;
      loadMoreWrap.hidden = currentMatches.length <= visibleCount;
      setResultsMode(true);
      updateUrl();

      if (scrollToResults) {
        (currentMatches.length ? results : empty).scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function selectVehicle(make, model, category, shouldScroll) {
      populateMakes(make || '');
      populateModels(model || '');
      if (model) modelSelect.value = model;
      populateProductTypes(category || '');
      visibleCount = PAGE_SIZE;
      renderMatches(shouldScroll !== false);
    }

    yearSelect.addEventListener('change', function () {
      var currentMake = makeSelect.value;
      var currentModel = modelSelect.value;
      var currentCategory = categorySelect.value;
      populateMakes(currentMake);
      populateModels(currentModel);
      populateProductTypes(currentCategory);
    });
    makeSelect.addEventListener('change', function () {
      var currentCategory = categorySelect.value;
      populateModels('');
      populateProductTypes(currentCategory);
    });
    modelSelect.addEventListener('change', function () {
      populateProductTypes(categorySelect.value);
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      visibleCount = PAGE_SIZE;
      renderMatches(true);
    });

    root.querySelector('[data-vdi-browse-all]').addEventListener('click', function () {
      yearSelect.value = '';
      populateMakes('');
      populateModels('');
      populateProductTypes('');
      searchInput.value = '';
      visibleCount = PAGE_SIZE;
      renderMatches(true);
    });

    root.querySelector('[data-vdi-reset]').addEventListener('click', function () {
      form.reset();
      populateMakes('');
      populateModels('');
      populateProductTypes('');
      visibleCount = PAGE_SIZE;
      currentMatches = [];
      results.hidden = true;
      empty.hidden = true;
      loadMoreWrap.hidden = true;
      setResultsMode(false);
      updateUrl();
    });

    if (changeToggle) {
      changeToggle.addEventListener('click', function () {
        var isOpen = root.classList.toggle('vdi-finder--filters-open');
        changeToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) yearSelect.focus();
      });
    }

    loadMoreButton.addEventListener('click', function () {
      visibleCount += PAGE_SIZE;
      renderMatches(false);
    });

    root.querySelectorAll('[data-vdi-popular]').forEach(function (button) {
      button.addEventListener('click', function () {
        yearSelect.value = '';
        searchInput.value = '';
        selectVehicle(button.getAttribute('data-make'), button.getAttribute('data-model'), '', true);
      });
    });

    makeList.addEventListener('click', function (event) {
      var button = event.target.closest('button[data-make]');
      if (!button) return;
      yearSelect.value = '';
      searchInput.value = '';
      selectVehicle(button.getAttribute('data-make'), '', '', true);
    });

    var c8ApparelButton = root.querySelector('[data-vdi-c8-apparel]');
    if (c8ApparelButton) {
      c8ApparelButton.addEventListener('click', function () {
        yearSelect.value = '';
        searchInput.value = '';
        selectVehicle('Chevrolet', 'Corvette C8', 'apparel', true);
      });
    }

    var params = new URLSearchParams(window.location.search);
    var initialMake = params.get('make') || '';
    var initialModel = params.get('model') || '';
    yearSelect.value = params.get('year') || '';
    populateMakes(initialMake);
    populateModels(initialModel);
    if (initialModel) modelSelect.value = initialModel;
    populateProductTypes(params.get('product_type') || '');
    searchInput.value = params.get('q') || '';
    if (yearSelect.value || initialMake || initialModel || categorySelect.value || searchInput.value) renderMatches(false);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var catalog = window.VDI_VEHICLE_CATALOG;
    if (!catalog || !Array.isArray(catalog.products)) return;
    document.querySelectorAll('[data-vdi-vehicle-finder]').forEach(function (root) {
      init(root, catalog);
    });
  });
}());
